import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business } from '../../data/site';
import { whatsappLink } from '../../utils/whatsapp';
export function FloatingActions() {
  const {
    t
  } = useLanguage();
  return <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3 sm:bottom-7 sm:right-7" data-id="element-129" data-mp="aat39wk28nse">
      <a href={business.phoneHref} aria-label={t.common.fab.call} className="flex h-14 w-14 items-center justify-center rounded-full bg-mauve text-white shadow-lg shadow-ink/20 transition-transform duration-150 ease-smooth active:scale-95 md:hidden" data-id="element-130" data-mp="17yl02pf7hmzg">
        <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="t11242gq8s2s" />
      </a>
      <a href={whatsappLink()} target="_blank" rel="noreferrer" aria-label={t.common.fab.whatsapp} className="flex h-14 items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-4 text-white shadow-lg shadow-ink/20 transition-transform duration-150 ease-smooth hover:-translate-y-0.5 active:scale-95 sm:pr-5" data-id="element-132" data-mp="t2vegsdxnbv9">
        <MessageCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-133" data-mp="19466ek6chyt3" />
        <span className="hidden text-sm font-medium leading-tight sm:block" data-id="element-134" data-mp="u6ni1ixkxnm6">
          WhatsApp
          <span className="block text-[11px] font-normal text-white/90" data-id="element-135" data-mp="z5qbe64765eb">{t.common.fab.reply}</span>
        </span>
      </a>
    </div>;
}